export const ROOT = "/products";

export const ALL_PRODUCTS = "all";

export const BASE_NAME = "/paintShop";
